<script lang="ts">
    import type Employees from "@/schemas/public/Employees";
    import AppLayout from "@/layouts/AppLayout.svelte";
    import {Plus} from "lucide-svelte";
    import type Blocks from "@/schemas/public/Blocks";
    import type {Field} from "@/types/types";
    import EmployeeTable from "@/components/employees/EmployeeTable.svelte";
    import CreateEmployeeModal from "@/components/employees/CreateEmployeeModal.svelte";

    type Row = Employees;

    type Props = {
        blocks: (Blocks & { fields: Field[] })[];
    };

    let {blocks}: Props = $props();

    let breadcrumbs = $state([
        {title: 'Employees', href: route('employees.index')},
    ]);

    let showCreateEmployeeModal = $state(false);

    function openCreateEmployeeModal() {
        showCreateEmployeeModal = true;
    }

    let view = "index";

    let actionbuttons = $state([
        {
            title: 'Add New Employee',
            href: undefined,
            icon: Plus,
            onClick: openCreateEmployeeModal,
        },
    ]);

</script>

<svelte:head>
    <title>Employees</title>
</svelte:head>

<!--<HeaderActionButtons>-->
<!--    {#if meta.user?.view_type === 'super-admin' || meta.user?.view_type === 'supervisory-body'}-->
<!--        <Button href={route('assessors.create')}>Add New Assessor</Button>-->
<!--    {/if}-->

<!--</HeaderActionButtons>-->
<AppLayout {breadcrumbs} {actionbuttons}>
    <EmployeeTable {view}>

    </EmployeeTable>
    <CreateEmployeeModal
        blocks={blocks}
        bind:show={showCreateEmployeeModal}
    />
</AppLayout>
